export const coerceNumber = (val: unknown) => {
  if (typeof val === 'number') {
    return val;
  }
  if (typeof val === 'string') {
    const num = Number.parseFloat(val);
    if (!Number.isNaN(num)) {
      return num;
    }
  }

  return 0;
};
